<div class="db-progress-bar db-progress-bar_size_{{size}} db-progress-bar_state_{{state}} sl-action-progress"
     [ngStyle]="{width: width ? width : '100%' }">
  <div class="db-progress-bar__progress {{color}} sl-action-progress-{{state}}" [ngStyle]="{width: progressPercent + '%'}"></div>
</div>
